import truckSettlement from './src/truckSettlement.vue'
import addPayment from './src/addPayment.vue'
import addWaybill from './src/addWaybill.vue'
import waybillReport from './src/wayBillReport.vue'
import paymentAccountBalance from "./src/paymentAccountBalance";
import paymentAccountOperation from "./src/paymentAccountOperation";

export default {
    truckSettlement,
    addPayment,
    addWaybill,
    waybillReport,
    paymentAccountBalance,
    paymentAccountOperation
}
